import {
  AEMErrorMessage,
  AEMFeatureFlags,
  AEMSummary,
  ComponentType
} from '@com-delta-idp/mnx-skymiles-shared';
import { AEMContent, AEMWelcomeTour } from './aem';
import { AEMOverview } from './aem/overview.interface';
import { MultiplePersonalizationEngineResponse, SkyClubResponse } from './api';
import { AccountSnapshotResponse } from './api/account-snapshot.interfaces';
import { EarnsSummaryResponse } from './api/earns-summary.interfaces';
import {
  FutureActivityDisabled,
  FutureActivityResponse
} from './api/future-activities.interfaces';
import { MembershipCardResponse } from './api/membership-card.interfaces';
import { StatusTrackerResponse } from './api/tracker.interfaces';
import { EDocsResponse, VouchersResponse } from './api/upgrades.interface';
import { Features } from './features.interfaces';

export interface OverviewErrorEntity {
  summaryError?: string;
  multiplePEContentError?: string;
  statusTrackerContentError?: string;
  futureActivityContentError?: string;
  membershipCardError?: string;
  vouchersContentError?: string;
  eDocsContentError?: string;
  snapshotDataError?: string;
  aemContentError?: ComponentType;
  aemFeatureFlagsError?: ComponentType;
  aemWelcomeTourError?: ComponentType;
  aemErrorMessagesError?: ComponentType;
  aemSummaryContentError?: ComponentType;
  earnsSummaryDataError?: string;
  skyclubTrackerDataError?: string;
  amexSkyClubTrackerDataError?: string;
}

export interface OverviewEntity extends OverviewErrorEntity {
  id: string | number; // Primary ID
  summary?: AEMSummary;
  multiplePEContent?: MultiplePersonalizationEngineResponse;
  statusTrackerContent?: StatusTrackerResponse;
  futureActivityContent?: FutureActivityResponse | FutureActivityDisabled;
  membershipCard?: MembershipCardResponse;
  vouchersContent?: VouchersResponse;
  eDocsContent?: EDocsResponse;
  snapshotData?: AccountSnapshotResponse;
  aemContent?: AEMContent;
  aemSummaryContent?: AEMOverview;
  aemFeatureFlags?: AEMFeatureFlags<Features>;
  aemWelcomeTour?: AEMWelcomeTour;
  aemErrorMessages?: AEMErrorMessage[];
  earnsSummaryData?: EarnsSummaryResponse;
  skyclubTrackerData?: SkyClubResponse;
  amexSkyClubTrackerData?: SkyClubResponse;
}
